module.exports = __webpack_public_path__ + "static/media/salsichalanche.260ef8dc.webp";